import { resolveImagePath } from '@/utils/imageResolver';

export function Header() {
  const headerImageUrl = resolveImagePath('/images/yak52-header.jpg');

  return (
    <header className="relative bg-background">
      {/* Airplane Hero Image */}
      <div className="relative w-full">
        <img
          src={headerImageUrl}
          alt="Blue Yak-52 aircraft at Border Air Ltd"
          className="w-full h-auto object-cover"
          width={1180}
          height={359}
        />
      </div>
      
      {/* Navigation Bar */}
      <nav className="bg-background-nav">
        <div className="max-w-full">
          <ul className="flex justify-center space-x-0">
            <li>
              <a
                href="/"
                className="block px-8 py-4 text-white font-body font-bold text-[15px] uppercase tracking-wider hover:bg-black/20 transition-colors"
              >
                HOME
              </a>
            </li>
            <li>
              <a
                href="/contact"
                className="block px-8 py-4 text-white font-body font-bold text-[15px] uppercase tracking-wider hover:bg-black/20 transition-colors"
              >
                CONTACT
              </a>
            </li>
            <li>
              <a
                href="/flat-rate-inspections"
                className="block px-8 py-4 text-white font-body font-bold text-[15px] uppercase tracking-wider hover:bg-black/20 transition-colors"
              >
                FLAT RATE INSPECTIONS
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}